<mobile-page-content [fullPageWidth]="true">
    <app-mobile-header header [hasSideMenu]="true"></app-mobile-header>

    <app-mobile-side-menu right-menu></app-mobile-side-menu>

    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>

    <div class="evaluation-athlete-show">
        <mobile-module-content *ngIf="!is401 && !is404" [title]="evaluationAthlete['evaluation']?.title ?? ''">
            <mat-card-header class="evaluation-athlete-status">
                <mat-card-subtitle>
                    <mat-chip-set>
                        <mat-chip [ngClass]="evaluationAthlete.status === 'opened' ? 'mat-chip-accent' : ''">{{ evaluationAthlete.status??'' | translate }}</mat-chip>
                    </mat-chip-set>
                </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content class="evaluation-athlete-content mb-20">
                <div class="evaluation-athlete-date mb-10">{{ 'EvaluationOf' | translate:{date: (evaluationAthlete.date|appDate:'mediumDate')} }}</div>
                <div class="evaluation-athlete-descriptions">{{ evaluationAthlete['evaluation']?.description }}</div>
            </mat-card-content>

            <div class="header">
                <form [formGroup]="evaluationForm">
                    <fieldset [disabled]="isSubmitting">
                        <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="20px" class="mt-40">
                            <div [fxFlex]="this.evaluationAthlete['rights'].edit && this.evaluationAthlete['rights'].editAthleteAnswers ? 50 : 100">
                                <div class="questions-wrapper">
                                    <div class="user user-athlete">
                                        {{ 'Athlete' | translate }}
                                    </div>
                                    <div class="questions">
                                        <evaluation-athlete-question-group user="athlete"
                                                                           [athleteId]="evaluationAthlete.athleteId"
                                                                           [evaluationAthlete]="evaluationAthlete"
                                                                           [evaluationForm]="evaluationForm"
                                                                           [isDesktop]="this.isDesktop"
                                                                           (onFormChanged)="onFormChanged()">
                                        </evaluation-athlete-question-group>
                                    </div>
                                </div>
                            </div>
                            <div fxFlex="50" *ngIf="this.evaluationAthlete['rights'].edit && this.evaluationAthlete['rights'].editCoachAnswers">
                                <div class="questions-wrapper">
                                    <div class="user user-coach">
                                        {{ 'Coach' | translate }}
                                    </div>
                                    <div class="questions">
                                        <evaluation-athlete-question-group user="coach"
                                                                           [athleteId]="evaluationAthlete.athleteId"
                                                                           [evaluationAthlete]="evaluationAthlete"
                                                                           [evaluationForm]="evaluationForm"
                                                                           [isDesktop]="this.isDesktop"
                                                                           (onFormChanged)="onFormChanged()">
                                        </evaluation-athlete-question-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="this.evaluationAthlete['rights'].edit && this.evaluationAthlete['rights'].viewNotes">
                            <mat-form-field style="width: 100%;">
                                <mat-label>{{ 'Evaluation_notes' | translate }}</mat-label>
                                <textarea
                                        formControlName="notes"
                                        matInput
                                        cdkTextareaAutosize
                                        cdkAutosizeMinRows="1"
                                        cdkAutosizeMaxRows="5"></textarea>
                            </mat-form-field>
                        </div>

                    </fieldset>
                </form>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" class="pull-left" *ngIf="evaluationAthlete.status == 'opened'">
                <div *ngIf="!is401 && !is404 && this.evaluationAthlete['rights'].close">
                    <button mat-raised-button color="primary" (click)="closeEvaluation()">{{ 'CloseEvaluation' | translate }}</button>
                </div>
            </div>
        </mobile-module-content>
    </div>

    <ng-container *ngIf="!is401 && !is404 && this.evaluationAthlete['rights'].edit">
        <main-action [title]="'Save'"
                     [icon]="'check'"
                     [isLoading]="isSubmitting"
                     [disabled]="isLoading"
                     (click)="onSaveClicked()"
        >
        </main-action>
        <main-action *ngIf="this.evaluationAthlete['rights'].edit"
                     [title]="'Close_edit_mode' | translate"
                     [icon]="'close'"
                     [color]="'none'"
                     [right]="104"
                     [disabled]="isLoading"
                     [link]="'/' + organization.code + '/app/athletes/' + athleteUser.id +'/evaluations/' + evaluationAthlete.id"
        >
        </main-action>
    </ng-container>
</mobile-page-content>

